var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Badge, Flex, Text, getPaletteColor } from 'pcln-design-system';
var BorderText = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-radius: ", ";\n  border: 1px solid ", ";\n  width: inherit;\n"], ["\n  border-radius: ", ";\n  border: 1px solid ", ";\n  width: inherit;\n"])), themeGet('borderRadii.sm'), getPaletteColor('background.lightest'));
var CardBadge = styled(Badge)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var Badges = function (_a) {
    var badgeText = _a.badgeText, borderText = _a.borderText, textColor = _a.textColor, pb = _a.pb;
    if (!badgeText && !borderText) {
        return null;
    }
    var topFlexJustify = 'space-between';
    if (!badgeText && borderText) {
        topFlexJustify = 'flex-end';
    }
    else if (badgeText && !borderText) {
        topFlexJustify = 'flex-start';
    }
    return (React.createElement(Flex, { alignItems: 'center', justifyContent: topFlexJustify, pb: [2, null, null, null, 3], mb: 1 },
        badgeText && (React.createElement(CardBadge, { bg: 'highlight.light', color: 'success.dark', size: 'small' }, badgeText)),
        borderText && (React.createElement(BorderText, { color: textColor, px: 1, py: '3px', textAlign: 'center', textStyle: 'label' }, borderText))));
};
export default Badges;
var templateObject_1, templateObject_2;
//# sourceMappingURL=Badges.js.map